import moment from "moment";
import { getTimeToShipment } from "../../../reducers/catalogBulkUploadCopy/catalogBulkValidationHelper";
import {
  formatNumber,
  getProductCodeLength,
  getSelectedCountryByCode,
  getSelectedCountryCodeByName,
  removeNewlines,
} from "../../../utils/helper";
import {
  formatTimeToShip,
  prepareAddProductPhotoData,
} from "../../../utils/postDataHelpers/CatalogHelper";
import { parseDbObjectInsideArray } from "../../../utils/validationHelper";
import {
  checkObjectHasValue,
  checkValidMonthYear,
  convertDateFormat,
  getProfileId,
} from "../../../utils/validationUtils";

export const getNextButtonText = ({
  currentPage,
  selectedRowCount,
  isDynamicSpecEmpty,
  ondcSpecLoader,
  selectedOndcSpecCount,
}) => {
  switch (currentPage) {
    case "provide-sku":
      return "NEXT";

    case "sync-sku":
      return "CONTINUE";

    case "assign-category":
      // return isAssignCatError ? `VERIFY & CONTINUE(${selectedRowCount} ROWS)` : "NEXT";
      return `VERIFY & CONTINUE(${selectedRowCount} ROWS)`;

    case "product-info":
      return `VERIFY & CONTINUE(${selectedRowCount} ROWS)`;

    case "ondc":
      return `VERIFY & CONTINUE(${selectedRowCount} ROWS)`;

    case "ondcSpecGroup":
      return `CHOOSE & CONTINUE`;

    case "addOndcSpecs":
      return !ondcSpecLoader && isDynamicSpecEmpty
        ? `IMPORT ROWS`
        : `VERIFY & IMPORT`;

    default:
      return "NEXT";
  }
};

export const prepareCatalogPartnerItemInfo = (
  partnerItemData,
  commerceInfo
) => {
  return {
    basePrice: partnerItemData?.basePrice || 0,
    brand: partnerItemData?.brand || "",
    catalogPartner: commerceInfo?.catalogPartnerInfo?.[0]?.catalogPartner || "",
    facilityCode:
      commerceInfo?.catalogPartnerInfo?.[0]?.warehouse?.facilityCode || "",
    color: partnerItemData?.color || "",
    ean: partnerItemData?.ean || "",
    expirable: partnerItemData?.expirable || true,
    expiryDate: partnerItemData?.expiryDate || "",
    fragile: partnerItemData?.fragile || true,
    gstTaxTypeCode: partnerItemData?.gstTaxTypeCode || "",
    height: partnerItemData?.height || "",
    hsn: partnerItemData?.hsn || "",
    isbn: partnerItemData?.isbn || "",
    length: partnerItemData?.length || "",
    maxRetailPrice: partnerItemData?.maxRetailPrice || "",
    minOrderSize: partnerItemData?.minOrderSize || "",
    productDescription: partnerItemData?.description || "",
    productName: partnerItemData?.name || "",
    scanType: partnerItemData?.scanType || "",
    shelfLife: partnerItemData?.shelfLife || "",
    size: partnerItemData?.size || "",
    skuCode: partnerItemData?.skuCode || "",
    skuType: partnerItemData?.skuType || "",
    taxTypeCode: partnerItemData?.taxTypeCode || "",
    type: partnerItemData?.type || "",
    upc: partnerItemData?.upc || "",
    weight: partnerItemData?.weight || "",
    width: partnerItemData?.width || "",
  };
};

export const prepareProductSyncData = (data) => {
  const profileId = getProfileId();
  const businessId = data?.businessId;
  const businessInfo = data?.businessInfo;
  const partnerItemData = data?.partnerItemData;
  const commerceInfo = data?.commerceInfo;
  const partnerProductId = data?.partnerProductId || "";

  const lat = businessInfo?.loc?.y || "";
  const long = businessInfo?.loc?.x || "";

  const gstRates = data?.gstRates || [];

  console.log("data?.gst", data?.gst);
  
  const isGstValid = gstRates?.find(
    (item) => item?.value == formatNumber(data?.gst || 0)
  );

  // multiple images
  const imageLinks = data?.buyMoreImageLinks || [];
  let productPhotoUrl = [];

  // Check if imageLinks array exists and has items
  if (imageLinks.length > 0) {
    // Find the productImages for the given partnerProductId
    const productImages = imageLinks.find(
      (product) => product[partnerProductId]
    );

    if (productImages) {
      // Extract and process the image links
      const images = Object.keys(productImages[partnerProductId] || {})
        .filter((key) => key.startsWith("image_link_"))
        .sort() 
        .map((key) => productImages[partnerProductId][key]); // Get image link values

      // Push the first four images or fallback to a default image
      productPhotoUrl =
        images.length > 0 ? images.slice(0, 4) : [data?.imageUrl];
    } else {
      // Fallback if no productImages are found
      productPhotoUrl = [data?.imageUrl];
    }
  } else {
    productPhotoUrl = [data?.imageUrl];
  }

  console.log("Product Photo URLs:", productPhotoUrl);

  const postData = {
    catalogPartnerItemInfo: [
      {
        ...data?.catalogPartnerItemInfo,
        // basePrice: partnerItemData?.basePrice || 0,
        // brand: partnerItemData?.brand || "",
        // catalogPartner: commerceInfo?.catalogPartnerInfo?.[0]?.catalogPartner || "",
        // facilityCode: commerceInfo?.catalogPartnerInfo?.[0]?.warehouse?.facilityCode || "",
        // color: partnerItemData?.color || "",
        // ean: partnerItemData?.ean || "",
        // expirable: partnerItemData?.expirable || true,
        // expiryDate: partnerItemData?.expiryDate || "",
        // fragile: partnerItemData?.fragile || true,
        // gstTaxTypeCode: partnerItemData?.gstTaxTypeCode || "",
        // height: partnerItemData?.height || "",
        // hsn: partnerItemData?.hsn || "",
        // isbn: partnerItemData?.isbn || "",
        // length: partnerItemData?.length || "",
        // maxRetailPrice: partnerItemData?.maxRetailPrice || "",
        // minOrderSize: partnerItemData?.minOrderSize || "",
        // productDescription: partnerItemData?.description || "",
        // productName: partnerItemData?.name || "",
        // scanType: partnerItemData?.scanType || "",
        // shelfLife: partnerItemData?.shelfLife || "",
        // size: partnerItemData?.size || "",
        // skuCode: partnerItemData?.skuCode || "",
        // skuType: partnerItemData?.skuType || "",
        // taxTypeCode: partnerItemData?.taxTypeCode || "",
        // type: partnerItemData?.type || "",
        // upc: partnerItemData?.upc || "",
        // weight: partnerItemData?.weight || "",
        // width: partnerItemData?.width || "",
      },
    ],
    profileId: profileId,
    businessId: businessId,
    productName: data?.productName,
    productDescription: data?.description,
    catalogType: "Product",
    businessResellerFlag: "Y",
    clientType: "business-dashboard-web",
    label: [],
    searchText: "",
    brand: data?.brand || "",
    origin: "IND",
    skuId: data?.skuCode || null,
    refLink: [],
    // productPhotoUrl: partnerItemData?.imageUrl
    //   ? [`${partnerItemData?.imageUrl}`]
    //   : [],
    // productPhotoUrl: data?.imageUrl ? [`${data?.imageUrl}`] : [],
    productPhotoUrl,

    latitude: lat,
    longitude: long,
    status: "active",
    commerceEnabled: "YES",
    hyperLocal: "Y",
    productMainCategory: [],
    productSubCategory: [],
    productSubCategory2: [],
    commerceStartDate: "",
    commerceEndDate: "",
    minOrderQuantity: "",
    maxOrderQuantity: "",
    productOriginalPrice: data?.maxRetailPrice,
    productSalePrice: "",
    gstInfo: {
      code: ":",
      gstPercentage: isGstValid ? formatNumber(data?.gst) : "",
    },
    measurementInfo: {
      weight: data?.weight || "",
      length: data?.length || "",
      width: data?.width || "",
      height: data?.height || "",
    },
    taxDetails: [
      {
        code: "Inclusive of taxes",
        name: "Taxes Included",
        value: "false",
      },
    ],
    currencySymbol: "₹",
    unitOfMeasure: "",
    availability: data?.enabled ? ["Yes"] : ["No"],
    deliveryType: [],
    shipmentDistance: "0",
    preference: 0,
    availableQuantity: "",
    soldQuantity: 0,
    alertQuantity: "",
    subscription: null,
    productDisplayUnitOfMeasure: {
      unit: data?.productMeasurementUnit || "",
      value: data?.productMeasurementValue || "",
    },
    netProductWeight: data?.shippingWeight || "",
    ondcEnabled: "no",
    ondc: {
      productCode: {
        key: data?.productCode || "",
        value: data?.productCodeValue || "",
      },
      fragile: false,
      available_on_cod: false,
      timeToShip: "",
      cancelTerms: {
        cancellable: "no",
        cancellationFeePercentage: "",
        refundEligible: "no",
        cancellationFeeAmount: null,
      },
      returnTerms: {
        returnable: "no",
        returnPeriod: "",
        seller_pickup_return: "no",
      },
    },
    notes: `${data?.skuCode}`,
  };

  return postData;
};

export const prepareDraftProductList = (skuInfo) => {
  if (!skuInfo || skuInfo.length == 0) return [];

  const profileId = getProfileId();

  const draftProducts = skuInfo?.map((item, index) => {
    const itemInfo = item?.itemTypeDTO || null;

    return {
      id: "",
      skuId: item?.skuCode || "",
      profileId: profileId,
      businessId: "",
      uploadedBy: profileId,
      productName: itemInfo?.name,
      productDescription: itemInfo?.description || "",
      catalogType: "product",
      searchText: "",
      productSearch: "",
      currencySymbol: "₹",
      status: "",
      commerceEnabled: "YES",
      brand: itemInfo?.brand || "",
      origin: "India",
      categoryPath: "",
      categoryCodePath: "",
      hyperLocal: "N",
      businessResellerFlag: null,
      costboHsnCode: null,
      offer: null,
      notes: null,
      productAddedBy: "",
      productUpdatedBy: "",
      ondcEnabled: "Yes",
      preference: 0,
      productOriginalPrice: itemInfo?.maxRetailPrice || 0,
      productSalePrice: 0,
      percentageOff: 0,
      minOrderQuantity: 0,
      maxOrderQuantity: 0,
      availableQuantity: 0,
      soldQuantity: 0,
      alertQuantity: 30,
      shipmentDistance: 4000,
      netProductWeight: 0,
      loc: {
        x: 0,
        y: 0,
        coordinates: [0, 0],
        type: "Point",
      },
      gstInfo: {
        code: null,
        gstPercentage: "",
      },
      packageInfo: null,
      measurementInfo: {
        weight: itemInfo?.weight || "",
        length: itemInfo?.length || "",
        width: itemInfo?.width || "",
        height: itemInfo?.height || "",
      },
      subscription: null,
      orderInfo: null,
      productDisplayUnitOfMeasure: {
        unit: "",
        value: 0,
      },
      ondc: {
        discount: 0,
        veg_nonveg: {
          veg: null,
          nonVeg: null,
          egg: null,
        },
        productCode: {
          key: "",
          value: "",
        },
        shelfLife: 0,
        fragile: false,
        timeToShip: "",
        available_on_cod: false,
        cancelTerms: {
          cancellable: "",
          cancellationFeeAmount: "",
          cancellationFeePercentage: "",
          refundEligible: "",
        },
        returnTerms: {
          returnable: "",
          returnPeriod: "",
          seller_pickup_return: "",
        },
        fssai: [],
        statutoryReqsPackagedCommodities: {
          manufacturer_or_packer_name: null,
          manufacturer_or_packer_address: null,
          common_or_generic_name_of_commodity: null,
          mfg_license_no: null,
          expiry_date: null,
          month_year_of_manufacture_packing_import: null,
          net_quantity_or_measure_of_commodity_in_pkg: null,
          multiple_products_name_number_or_qty: null,
        },
        statutoryReqsPrepackagedFood: {
          ingredients_info: null,
          nutritional_info: null,
          additives_info: null,
          brand_owner_FSSAI_license_no: null,
          other_FSSAI_license_no: null,
          importer_FSSAI_license_no: null,
          other_owner_FSSAI_license_no: null,
        },
        attributeList: [],
        foodType: "",
        fssaiNo: "",
        fssaiValidTill: "",
        foodRelatedItems: "NO",
        isPackaged: "NO",
        isPrePackaged: "NO",
        shipmentTime: "1",
        timeToShipUnit: {
          label: "Days",
        },
        returnPeriodDays: "7",
      },
      productPhoto: [],
      productPhotoUrl: [],
      questions: [],
      productMainCategory: [],
      productSubCategory: [],
      productSubCategory2: [],
      taxDetails: [
        {
          code: "Inclusive of taxes",
          value: "true",
          name: "Taxes Included",
        },
      ],
      label: [],
      availability: itemInfo?.enabled ? ["Yes"] : ["No"],
      deliveryType: ["Delivery/Fulfillment by Business"],
      refLink: [],
      activators: null,
      decliners: null,
      commerceStartDate: 0,
      commerceEndDate: 0,
      productAddedOn: null,
      productUpdatedOn: null,
      productLastViewDate: null,
      uploadedOn: 0,
      importedOn: null,
      productCodeKey: "",
      productCodeValue: "",
      unitOfmeasurement: "",
      unitOfmeasurementValue: 0,
    };
  });

  return draftProducts;
};

export const prepareProductDraftList = (productList, countryList) => {
  const allProducts = productList?.map((productInfo, index) => {
    const ondcInfo = productInfo?.ondc || null;
    // Product Attributes
    const productCodeKey = ondcInfo?.productCode?.key || "";
    const productCodeValue =
      typeof ondcInfo?.productCode?.value === "string"
        ? removeNewlines(ondcInfo?.productCode?.value)
        : ondcInfo?.productCode?.value || "";

    const unitOfmeasurement =
      productInfo?.productDisplayUnitOfMeasure?.unit?.trim() || "";
    const unitOfmeasurementValue =
      productInfo?.productDisplayUnitOfMeasure?.value || "";

    // ONDC Values
    const foodTypeData = ondcInfo?.veg_nonveg || null;

    let selectedValue = null;

    if (foodTypeData) {
      Object.keys(foodTypeData)?.forEach((item) => {
        if (foodTypeData[item] && foodTypeData[item]?.toLowerCase() === "yes") {
          if (!selectedValue) {
            selectedValue =
              item === "veg" ? "Veg" : item === "nonVeg" ? "Non Veg" : "Egg";
          }
        }
      });
    }

    const shelfLife = ondcInfo?.shelfLife;
    const fssaiNo = ondcInfo?.fssai?.[0]?.number || "";

    const fssaiValidTill = "";

    // const fssaiValidTill = ondcInfo?.fssai?.[0]?.validTill
    //   ? convertDateFormat(ondcInfo?.fssai?.[0]?.validTill)
    //   : "";

    const isFoodRelatedItems =
      shelfLife || fssaiNo || fssaiValidTill ? "YES" : "NO";

    const packagedInfo = ondcInfo?.statutoryReqsPackagedCommodities || null;
    const packaged = checkObjectHasValue(packagedInfo);

    const prePackagedInfo = ondcInfo?.statutoryReqsPrepackagedFood || null;
    const prePackaged = checkObjectHasValue(prePackagedInfo);

    const shipmentTime = getTimeToShipment(ondcInfo?.timeToShip);

    const origin =
      productInfo?.origin?.length <= 3
        ? getSelectedCountryByCode(productInfo?.origin, countryList)
        : productInfo?.origin;

    const productPhotos = productInfo?.productPhoto || [];

    const productImageInfo = Array.from({ length: 4 }, (_, index) => {
      const filteredImg = productPhotos?.filter((photoInfo) => {
        if (photoInfo?.docURL?.toLowerCase()?.includes(`product${index}`)) {
          return photoInfo;
        }
      });

      return {
        id: index,
        base64Str: filteredImg[0]?.docURL || null,
        imageInfo: filteredImg[0] || null,
      };

      // return {
      //   id: index + 1,
      //   base64Str: productPhotos[index]?.docURL || null,
      //   imageInfo: productPhotos[index] || null,
      // };
    });

    return {
      ...productInfo,
      origin,
      productCodeKey,
      productCodeValue,
      unitOfmeasurement,
      unitOfmeasurementValue,
      productImageInfo,
      deletedImageInfo: [],
      // measurementInfo: {
      //   ...productInfo?.measurementInfo,
      //   weight: productInfo?.netProductWeight || 0,
      // },
      // netProductWeight: productInfo?.measurementInfo?.weight || 0,

      ondc: {
        ...productInfo?.ondc,
        foodType: selectedValue || "Select Value",
        fssaiNo,
        fssaiValidTill,
        foodRelatedItems: isFoodRelatedItems,
        isPackaged: packaged ? "YES" : "NO",
        isPrePackaged: prePackaged ? "YES" : "NO",
        shipmentTime: shipmentTime?.timeData,
        timeToShipUnit: { label: shipmentTime?.timeUnit },
        returnPeriodDays:
          ondcInfo?.returnTerms?.returnPeriod?.replace(/[a-zA-Z]/g, "") || "0",
      },
    };
  });

  return allProducts;
};

const getUpdatedProductDetailsWithCategoryInfo = (data) => {
  const {
    productDetails,
    selectedBusinessCat,
    selectedProductCat,
    selectedProductSubCat,
    selectedOndcCat,
    selectedOndcSubCat,
    ondcSpecification,
  } = data;

  let allProducts = [...productDetails];

  productDetails.forEach((product, index) => {
    if (product?.isSelected) {
      let businessCatData = {
        code: null,
        value: null,
        status: null,
        ondcCode: null,
        ondcValue: null,
      };

      if (selectedBusinessCat) {
        businessCatData = {
          ...businessCatData,
          code: selectedBusinessCat?.code || null,
          value: selectedBusinessCat?.name || null,
          status: "active",
        };
      }

      if (selectedOndcCat) {
        businessCatData = {
          ...businessCatData,
          ondcCode: selectedOndcCat?.code || null,
          ondcValue: selectedOndcCat?.name || null,
        };
      }

      let productCatData = {
        code: null,
        value: null,
        pcCode: null,
        status: null,
        pscCode1: null,
        ondcSubCode: null,
        ondcSubValue: null,
      };

      if (selectedProductCat) {
        productCatData = {
          ...productCatData,
          code: selectedProductCat?.pscCode1 || null,
          value: selectedProductCat?.productSubCategory1 || null,
          pcCode: selectedProductCat?.pcCode || null,
          status: "active",
          pscCode1: selectedProductCat?.scCode1 || null,
        };
      }

      if (selectedOndcSubCat) {
        productCatData = {
          ...productCatData,
          ondcSubCode: selectedOndcSubCat?.scCode1 || null,
          ondcSubValue: selectedOndcSubCat?.productSubCategory1 || null,
        };
      }

      let productSubCatData = {
        code: null,
        value: null,
        pcCode: null,
        psCode: null,
        status: null,
        pscCode2: null,
      };

      if (selectedProductSubCat) {
        productSubCatData = {
          ...productSubCatData,
          code: selectedProductSubCat?.pscCode2 || null,
          value: selectedProductSubCat?.productSubCategory2 || null,
          pcCode: selectedProductSubCat?.pcCode || null,
          psCode:
            selectedProductSubCat?.pcCode + selectedProductSubCat?.scCode1,
          status: "active",
          pscCode2: "",
        };
      }

      const ondcInfo = product?.ondc || null;

      let productCodeKey = ondcInfo?.productCode?.key || "";
      let productCodeValue =
      typeof ondcInfo?.productCode?.value === "string"
        ? removeNewlines(ondcInfo?.productCode?.value)
        : ondcInfo?.productCode?.value || "";

      const catalogPartnerData = product?.catalogPartnerItemInfo?.[0] || null

      if(catalogPartnerData?.catalogPartner?.toLowerCase() == "unicommerce"){
        if(businessCatData?.ondcValue == "Grocery"){
          productCodeKey = "EAN"
          productCodeValue = catalogPartnerData?.ean || ''
        }else{
          productCodeKey = "HSN"
          productCodeValue = catalogPartnerData?.hsn || ''
        }
      }

      allProducts[index] = {
        ...allProducts[index],
        productMainCategory: [businessCatData],
        productSubCategory: [productCatData],
        productSubCategory2: productSubCatData?.value
          ? [productSubCatData]
          : [],
        ondcSpecification: ondcSpecification,
        errors: null,
        productCodeKey,
        productCodeValue,
      };
    }
  });

  const finalData = allProducts?.map((item) => {
    const data = { ...item };
    delete data.errors;
    return data;
  });

  return finalData;
};

// Validate Draft Product Category Input
export const validateDraftProductCategoryInfo = (productList) => {
  let allProducts = [...productList];

  let isError = false;

  productList.forEach((product, index) => {
    let errors = null;

    if (!product.isSelected) return;

    if(!product?.productName){
      errors = {
        ...errors,
        productName: "Enter product name",
      };
    } else {
      delete errors?.productName;
    }

    if (!product?.productMainCategory?.[0]?.value) {
      errors = {
        ...errors,
        productMainCategory: "Select business category",
      };
    } else {
      delete errors?.productMainCategory;
      // errors = { ...errors, productMainCategory: "" };
    }

    if (!product?.productSubCategory?.[0]?.value) {
      errors = { ...errors, productSubCategory: "Select product category" };
    } else {
      delete errors?.productSubCategory;
      // errors = { ...errors, productSubCategory: "" };
    }

    if (!product?.productMainCategory?.[0]?.ondcValue) {
      errors = {
        ...errors,
        selectedOndcCategory: "Select ONDC category",
      };
    } else {
      delete errors?.selectedOndcCategory;
      // errors = { ...errors, selectedOndcCategory: "" };
    }

    if (!product?.productSubCategory?.[0]?.ondcSubValue) {
      errors = {
        ...errors,
        selectedOndcSubCategory: "Select ONDC sub category",
      };
    } else {
      delete errors?.selectedOndcSubCategory;
    }

    if (errors) {
      allProducts[index] = {
        ...allProducts[index],
        errors: errors,
      };
      isError = true;
    }
  });

  console.log("validateDraftProductCategoryInfo_Verified:", allProducts);
  console.log("validateDraftProductCategoryInfo_isError:", isError);

  return {
    allProducts,
    isError,
  };
};

// update category data
export const updateCategoryDataHelper = (param) => {
  const {
    productDetails,
    selectedBusinessCat,
    selectedProductCat,
    selectedProductSubCat,
    selectedOndcCat,
    selectedOndcSubCat,
    businessId,
    ondcSpecification,
  } = param;

  const updateData = getUpdatedProductDetailsWithCategoryInfo({
    productDetails,
    selectedBusinessCat,
    selectedProductCat,
    selectedProductSubCat,
    selectedOndcCat,
    selectedOndcSubCat,
    ondcSpecification,
  });

  const updatePostData = [];

  updateData?.forEach((product) => {
    if (product?.isSelected) {
      const data = {
        id: product?.id,
        productName: removeNewlines(product?.productName),
        productMainCategory: product?.productMainCategory,
        productSubCategory: product?.productSubCategory,
        productSubCategory2: product?.productSubCategory2,
      };
      updatePostData.push(data);
    }
  });

  return updateData;
};

// Validate Draft Product Info
export const validateDraftProductInfo = (
  productList,
  unitOfMeasurementData
) => {
  let allProducts = [...productList];

  let isError = false;

  productList.forEach((product, index) => {
    if (!product.isSelected) return;

    let errors = null;

    // if (!product?.productDescription) {
    //   errors = {
    //     ...errors,
    //     productDescription: "Enter product description",
    //   };
    // } else {
    //   delete errors?.productDescription;
    // }

    // if (!product?.brand) {
    //   errors = {
    //     ...errors,
    //     brand: "Enter brand name",
    //   };
    // } else {
    //   delete errors?.brand;
    // }

    if (!product?.origin) {
      errors = {
        ...errors,
        origin: "Select origin",
      };
    } else {
      delete errors?.origin;
    }

    if (
      !product?.productImageInfo?.[0]?.base64Str ||
      product?.productImageInfo?.[0]?.base64Str === ""
    ) {
      errors = {
        ...errors,
        productPhotoUrl: "Add product image",
      };
    } else {
      delete errors?.productPhotoUrl;
    }

    if (!product?.gstInfo?.gstPercentage) {
      errors = {
        ...errors,
        gstPercentage: "Select GST percentage",
      };
    } else {
      delete errors?.gstPercentage;
    }

    if (
      !product?.unitOfmeasurement ||
      product?.unitOfmeasurement === "Select Unit Of Measurement"
    ) {
      errors = {
        ...errors,
        unitOfmeasurement: "Select Unit Of Measurement",
      };
    } else {
      delete errors?.unitOfmeasurement;
    }

    const isSelectedUnitValid = unitOfMeasurementData?.find(
      (item) => item?.value == product?.unitOfmeasurement?.toLowerCase()
    );

    if (!isSelectedUnitValid) {
      errors = {
        ...errors,
        unitOfmeasurement: "Select Unit Of Measurement",
      };
    } else {
      delete errors?.unitOfmeasurement;
    }

    if (!product?.unitOfmeasurementValue) {
      errors = {
        ...errors,
        unitOfmeasurementValue: "Enter unit value",
      };
    } else {
      delete errors?.unitOfmeasurementValue;
    }

    if (
      !Number.isInteger(Number(product?.unitOfmeasurementValue)) ||
      !product?.unitOfmeasurementValue
    ) {
      errors = {
        ...errors,
        unitOfmeasurementValue: "Enter integer value",
      };
    } else {
      delete errors?.unitOfmeasurementValue;
    }

    if (!product?.productOriginalPrice) {
      errors = {
        ...errors,
        productOriginalPrice: "Enter original price",
      };
    } else {
      delete errors?.productOriginalPrice;
    }

    if (!product?.productSalePrice) {
      errors = {
        ...errors,
        productSalePrice: "Enter offer price",
      };
    } else {
      delete errors?.productSalePrice;
    }

    if (product?.productSalePrice && product?.productOriginalPrice) {
      if (
        Number(product?.productSalePrice) >
        Number(product?.productOriginalPrice)
      ) {
        errors = {
          ...errors,
          productSalePrice:
            "Offer Price must be less than or equal to Original Price",
        };
      }
    }

    // if (!product?.availableQuantity) {
    //   errors = {
    //     ...errors,
    //     availableQuantity: "Enter qty on hand",
    //   };
    // } else {
    //   delete errors?.availableQuantity;
    // }

    if (!product?.alertQuantity) {
      errors = {
        ...errors,
        alertQuantity: "Enter alert qty",
      };
    } else {
      delete errors?.alertQuantity;
    }

    if (!product?.minOrderQuantity) {
      errors = {
        ...errors,
        minOrderQuantity: "Enter minimum qty",
      };
    } else {
      delete errors?.minOrderQuantity;
    }

    if (!product?.maxOrderQuantity) {
      errors = {
        ...errors,
        maxOrderQuantity: "Enter maximum qty",
      };
    } else {
      delete errors?.maxOrderQuantity;
    }

    // if (
    //   // product?.availableQuantity &&
    //   product?.alertQuantity &&
    //   product?.maxOrderQuantity
    // ) {
    //   if (
    //     Number(product?.availableQuantity) <= Number(product?.alertQuantity) ||
    //     Number(product?.availableQuantity) < Number(product?.maxOrderQuantity)
    //   ) {
    //     errors = {
    //       ...errors,
    //       availableQuantity:
    //         "Qty On Hand should be greater than Alert Qty & Max Qty",
    //     };
    //   } else {
    //     delete errors?.availableQuantity;
    //   }
    // }

    if (product?.maxOrderQuantity && product?.minOrderQuantity) {
      if (
        Number(product?.maxOrderQuantity) < Number(product?.minOrderQuantity)
      ) {
        errors = {
          ...errors,
          maxOrderQuantity:
            "Max Qty per order should be greater than Min Qty per order",
        };
      } else {
        delete errors?.maxOrderQuantity;
      }
    }

    if (!product?.measurementInfo?.weight) {
      errors = {
        ...errors,
        weight: "Enter product weight",
      };
    } else {
      delete errors?.weight;
    }

    if (!product?.netProductWeight || product?.netProductWeight === "") {
      errors = {
        ...errors,
        netProductWeight: "Enter net product weight",
      };
    } else {
      delete errors?.netProductWeight;
    }

    if (
      product?.netProductWeight !== "" &&
      product?.netProductWeight < product?.measurementInfo?.weight
    ) {
      errors = {
        ...errors,
        netProductWeight:
          "Net Product Weight should be more than Product Weight",
      };
    } else {
      delete errors?.netProductWeight;
    }

    if (errors != {} && errors) {
      allProducts[index] = {
        ...allProducts[index],
        errors: errors,
      };
      console.log("validateDraftProductInfo_errors", errors);
      isError = true;
    } else {
      allProducts[index] = {
        ...allProducts[index],
        errors: null,
      };
    }
  });

  console.log("validateDraftProductInfo_Verified:", allProducts);
  console.log("validateDraftProductInfo_isError:", isError);

  return {
    allProducts,
    isError,
  };
};

// Validate Draft Product ONDC Parameters
export const validateDraftProductOndcInfo = (
  productList,
  isRemoveONDCSpecs
) => {
  let allProducts = [...productList];

  let isError = false;

  productList.forEach((product, index) => {
    if (!product.isSelected) return;

    let errors = null;

    if (product?.ondcEnabled?.toUpperCase() === "YES") {
      if (!product?.ondc?.shipmentTime || product?.ondc?.shipmentTime == "0") {
        errors = { ...errors, shipmentTime: "Enter time to ship" };
      } else {
        delete errors?.shipmentTime;
      }

      // CancelTerms
      if (product?.ondc?.cancelTerms?.cancellable?.toUpperCase() === "YES") {
        if (
          !product?.ondc?.cancelTerms?.cancellationFeePercentage ||
          product?.ondc?.cancelTerms?.cancellationFeePercentage === ""
        ) {
          errors = {
            ...errors,
            cancellationFeePercentage: "Enter cancellation fee percentage",
          };
        } else {
          delete errors?.cancellationFeePercentage;
        }

        if (product?.ondc?.cancelTerms?.cancellationFeePercentage > 0) {
          if (product?.ondc?.cancelTerms?.cancellationFeePercentage > 100) {
            errors = {
              ...errors,
              cancellationFeePercentage:
                "Cancellation fee percentage should be less than or equal to 100",
            };
          } else {
            delete errors?.cancellationFeePercentage;
          }
        }
      }

      // return terms
      //   if (product?.ondc?.returnTerms?.returnable?.toUpperCase() === "YES") {
      if (
        !product?.ondc?.returnPeriodDays ||
        product?.ondc?.returnPeriodDays == "0"
      ) {
        errors = { ...errors, returnPeriod: "Enter return period" };
      } else {
        delete errors?.returnPeriod;
      }
      //   }

      if (!isRemoveONDCSpecs) {
        // food related items
        if (product?.ondc?.foodRelatedItems?.toUpperCase() === "YES") {
          if (!product?.ondc?.shelfLife || product?.ondc?.shelfLife == "0") {
            errors = { ...errors, shelfLife: "Enter shelfLife" };
          } else {
            delete errors?.shelfLife;
          }

          if (
            !product?.ondc?.foodType ||
            product?.ondc?.foodType == "Select Value"
          ) {
            errors = { ...errors, foodType: "Select value" };
          } else {
            delete errors?.foodType;
          }

          if (product?.ondc?.fssaiNo?.length !== 14) {
            errors = { ...errors, fssaiNo: "Enter 14 digit fssai number" };
          } else {
            delete errors?.fssaiNo;
          }

          // if (!product?.ondc?.fssaiValidTill) {
          //   errors = {
          //     ...errors,
          //     fssaiValidTill: "Enter fssai valid till date",
          //   };
          // } else {
          //   delete errors?.fssaiValidTill;
          // }

          // if (product?.ondc?.fssaiValidTill) {
          //   const isFssaiDateValid = validateDate(product?.ondc?.fssaiValidTill);
          //   if (!isFssaiDateValid) {
          //     errors = {
          //       ...errors,
          //       fssaiValidTill: "Enter fssai valid till date",
          //     };
          //   } else {
          //     delete errors?.fssaiValidTill;
          //   }
        }

        // packaged food
        if (product?.ondc?.isPackaged?.toUpperCase() === "YES") {
          if (
            !product?.ondc?.statutoryReqsPackagedCommodities
              ?.manufacturer_or_packer_name
          ) {
            errors = {
              ...errors,
              manufacturer_or_packer_name: "Enter manufacturer or packer name",
            };
          } else {
            delete errors?.manufacturer_or_packer_name;
          }

          if (
            !product?.ondc?.statutoryReqsPackagedCommodities?.mfg_license_no
          ) {
            errors = {
              ...errors,
              mfg_license_no: "Enter manufacturer license number",
            };
          } else {
            delete errors?.mfg_license_no;
          }

          if (
            !product?.ondc?.statutoryReqsPackagedCommodities
              ?.manufacturer_or_packer_address
          ) {
            errors = {
              ...errors,
              manufacturer_or_packer_address: "Enter address",
            };
          } else {
            delete errors?.manufacturer_or_packer_address;
          }

          if (
            !product?.ondc?.statutoryReqsPackagedCommodities
              ?.common_or_generic_name_of_commodity
          ) {
            errors = {
              ...errors,
              common_or_generic_name_of_commodity:
                "Enter product common/generic name",
            };
          } else {
            delete errors?.common_or_generic_name_of_commodity;
          }

          if (
            !product?.ondc?.statutoryReqsPackagedCommodities
              ?.month_year_of_manufacture_packing_import
          ) {
            errors = {
              ...errors,
              month_year_of_manufacture_packing_import: "Enter import date",
            };
          } else {
            delete errors?.month_year_of_manufacture_packing_import;
          }

          const packageImportDate =
            product?.ondc?.statutoryReqsPackagedCommodities
              ?.month_year_of_manufacture_packing_import;

          if (packageImportDate) {
            const isDateValid = checkValidMonthYear(packageImportDate);
            if (!isDateValid) {
              errors = {
                ...errors,
                month_year_of_manufacture_packing_import:
                  "Enter valid import date (MM/YYYY)",
              };
            } else {
              delete errors?.month_year_of_manufacture_packing_import;
            }
          }

          if (!product?.ondc?.statutoryReqsPackagedCommodities?.expiry_date) {
            errors = { ...errors, expiry_date: "Enter expiry date" };
          } else {
            delete errors?.expiry_date;
          }

          const packageExpiryDate =
            product?.ondc?.statutoryReqsPackagedCommodities?.expiry_date;

          if (packageExpiryDate) {
            const isDateValid = checkValidMonthYear(packageExpiryDate);
            if (!isDateValid) {
              errors = {
                ...errors,
                expiry_date: "Enter valid expiry date (MM/YYYY)",
              };
            } else {
              delete errors?.expiry_date;
            }
          }

          if (
            !product?.ondc?.statutoryReqsPackagedCommodities
              ?.net_quantity_or_measure_of_commodity_in_pkg
          ) {
            errors = {
              ...errors,
              net_quantity_or_measure_of_commodity_in_pkg: "Enter net quantity",
            };
          } else {
            delete errors?.net_quantity_or_measure_of_commodity_in_pkg;
          }

          if (
            !product?.ondc?.statutoryReqsPackagedCommodities
              ?.multiple_products_name_number_or_qty
          ) {
            errors = {
              ...errors,
              multiple_products_name_number_or_qty: "Enter multiple products",
            };
          } else {
            delete errors?.multiple_products_name_number_or_qty;
          }
        }

        // pre packaged food
        if (product?.ondc?.isPrePackaged?.toUpperCase() === "YES") {
          if (
            product?.ondc?.statutoryReqsPrepackagedFood
              ?.brand_owner_FSSAI_license_no?.length !== 14
          ) {
            errors = {
              ...errors,
              brand_owner_FSSAI_license_no: "Enter 14 digit fssai number",
            };
          } else {
            delete errors?.brand_owner_FSSAI_license_no;
          }

          if (
            product?.ondc?.statutoryReqsPrepackagedFood?.other_FSSAI_license_no
              ?.length !== 14
          ) {
            errors = {
              ...errors,
              other_FSSAI_license_no: "Enter 14 digit fssai number",
            };
          } else {
            delete errors?.other_FSSAI_license_no;
          }

          if (
            product?.ondc?.statutoryReqsPrepackagedFood
              ?.importer_FSSAI_license_no?.length !== 14
          ) {
            errors = {
              ...errors,
              importer_FSSAI_license_no: "Enter 14 digit fssai number",
            };
          } else {
            delete errors?.importer_FSSAI_license_no;
          }

          if (!product?.ondc?.statutoryReqsPrepackagedFood?.ingredients_info) {
            errors = {
              ...errors,
              ingredients_info: "Enter ingredients info",
            };
          } else {
            delete errors?.ingredients_info;
          }

          if (!product?.ondc?.statutoryReqsPrepackagedFood?.nutritional_info) {
            errors = {
              ...errors,
              nutritional_info: "Enter nutritional info",
            };
          } else {
            delete errors?.nutritional_info;
          }

          if (!product?.ondc?.statutoryReqsPrepackagedFood?.additives_info) {
            errors = { ...errors, additives_info: "Enter additives info" };
          } else {
            delete errors?.additives_info;
          }
        }
      }
    }

    if (errors) {
      allProducts[index] = {
        ...allProducts[index],
        ondcErrors: errors,
      };
      isError = true;
    } else {
      allProducts[index] = {
        ...allProducts[index],
        ondcErrors: null,
      };
    }
  });

  console.log("validateDraftProductOndcInfo_Verified:", allProducts);
  console.log("validateDraftProductOndcInfo_isError:", isError);

  return {
    allProducts,
    isError,
  };
};

// Validate Draft Product ONDC Specs
export const validateDraftOndcProductSpecs = (productDetails) => {
  // console.log("validateOndcProductSpecs__productDetails:", productDetails);

  const productList = [...productDetails];
  const updatedProductList = [];

  let isError = false;

  productList.forEach((productInfo) => {
    if (productInfo?.isSelected) {
      const productSpecs = [...productInfo?.specList];

      let specificationError = false;
      let errors = null;

      if (
        !productInfo?.productCodeKey ||
        productInfo?.productCodeKey === "Select Product Code"
      ) {
        errors = {
          ...errors,
          productCodeKey: "Select Product Code",
        };
      } else {
        delete errors?.productCodeKey;
      }

      if (!productInfo?.productCodeValue) {
        errors = {
          ...errors,
          productCodeValue: "Enter value",
        };
      } else {
        delete errors?.productCodeValue;
      }

      if (productInfo?.productCodeKey && productInfo?.productCodeValue) {
        const productCodeLookup = productInfo?.productCodeInfo?.find(
          (obj) => obj?.prodictCode === productInfo?.productCodeKey
        );

        let pcError = true;
        productCodeLookup?.validation?.forEach((pattern) => {
          const regex = new RegExp(
            pattern?.replace(/d/g, "\\d")?.replace(/\./g, "\\.")
          );
          if (regex.test(productInfo?.productCodeValue)) {
            pcError = false;
          }
        });

        if (pcError) {
          errors = {
            ...errors,
            productCodeValue: `Enter valid ${getProductCodeLength(
              productInfo?.productCodeInfo,
              productInfo?.productCodeKey
            )} digit product code`,
          };
        }
      }

      const updatedSpecsArray = productSpecs?.map((item) => {
        if (item?.type === "default") {
          return item;
        }
        if (
          !item?.inputValue &&
          item?.required?.toLowerCase() === "m" &&
          item?.type !== "radioButton"
        ) {
          specificationError = true;
          return { ...item, error: "Please enter, it's a mandatory value" };
        }
        if (
          item?.required?.toLowerCase() === "m" &&
          item?.type == "radioButton" &&
          item?.radioOptions?.every((obj) => obj.value === "")
        ) {
          specificationError = true;
          return { ...item, error: "Please select, it's a mandatory value" };
        }

        if (!item?.inputValue || item?.validation?.length === 0) {
          return { ...item, error: "" };
        }

        // const validationArray = JSON.parse(item?.validation);

        // console.log("validationArray", validationArray);

        // if (validationArray?.length === 0) {
        //   return { ...item, error: "" };
        // }

        for (let validation of item?.validation) {
          if (validation.substring(0, 5) !== "regex") {
            if (validation === item?.inputValue) {
              return { ...item, error: "" };
            }
          } else {
            const regexString = validation.match(/regex\((.+)\)/)[1];
            const regexPattern = regexString
              .replace(/d/g, "\\d")
              .replace(/\./g, "\\.");
            const regex = new RegExp(regexPattern);
            console.log(
              "regex inputValue",
              validation,
              regexPattern,
              item?.inputValue
            );
            if (regex.test(item?.inputValue)) {
              console.log("validation success");
              return { ...item, error: "" };
            }
          }
        }

        specificationError = true;
        return { ...item, error: "Please enter valid format" };
      });

      updatedProductList.push({
        ...productInfo,
        specList: updatedSpecsArray,
        specificationError,
        errors,
      });

      if (specificationError && !isError) {
        isError = true;
      }
    } else {
      // Clearing errors
      const productSpecs = [...productInfo?.specList];
      const updatedSpecsArray = productSpecs?.map((item) => ({
        ...item,
        error: "",
      }));

      updatedProductList.push({
        ...productInfo,
        specList: updatedSpecsArray,
        specificationError: false,
        errors: null,
      });
    }
  });

  console.log("validateDraftOndcProductSpecs__updatedProductList:", {
    updatedProductList,
    isError,
  });
  return { updatedProductList, isError };
};

// Prepare Update status Product
export const prepareUpdateDraftProductPostData = (
  productDetails,
  countryList,
  businessId,
  businessInfo
) => {
  if (!productDetails) return [];

  const allProducts = [...productDetails];

  const profileId = getProfileId();

  const lat = businessInfo?.loc?.y || "";
  const long = businessInfo?.loc?.x || "";

  console.log("prepareUpdateDraftProductPostData__allProducts:", allProducts);

  const updatePostData = [];

  allProducts?.forEach((product) => {
    const productSpecs = [...product?.specList];
    const dbSpecificationObj = parseDbObjectInsideArray(productSpecs);

    const ondcInfo = product?.ondc;
    const cancelTermsInfo = ondcInfo?.cancelTerms;
    const returnTermsInfo = ondcInfo?.returnTerms;

    const shipTimeUnit = ondcInfo?.timeToShipUnit?.label || "Minutes";
    const timeToShipUnit =
      shipTimeUnit === "Minutes" ? "M" : shipTimeUnit === "Hours" ? "H" : "D";

    if (product?.isSelected) {
      const addImagePostData = [];
      const deleteImagePostData = [];

      product?.productImageInfo?.forEach((image, index) => {
        const { fileDetails, base64Str } = image || {};

        if (fileDetails) {
          const { name: filename, type: mimeType } = fileDetails;

          const params = {
            imageIndex: index,
            productId: product?.id,
            businessId,
            filename,
            mimeType,
            dataURL: base64Str,
          };

          const addImgData = prepareAddProductPhotoData(params);
          addImagePostData.push(addImgData);
        }
      });

      product?.deletedImageInfo?.forEach((image, index) => {
        const deteleImgData = {
          imageId: image?.docType,
          productID: product?.id,
          businessID: businessId,
        };

        deleteImagePostData.push(deteleImgData);
      });

      const data = {
        catalogPartnerItemInfo: product?.catalogPartnerItemInfo || [],
        productId: product?.id,
        profileId: profileId,
        businessId: businessId,
        productName: product?.productName,
        catalogType: "Product",
        searchText: product?.searchText || "",
        clientType: "business-dashboard-web",
        commerceEnabled: "YES",
        latitude: lat,
        longitude: long,
        // status: "draft",
        status: "new",
        hyperLocal: "Y",
        deliveryType: ["Delivery/Fulfillment by Business"],
        shipmentDistance: 4000,
        soldQuantity: product?.soldQuantity || 0,
        subscription: null,
        taxDetails: [
          {
            code: "Inclusive of taxes",
            name: "Taxes Included",
            value: "TRUE",
          },
        ],
        availability: product?.availability || ["No"],
        commerceEndDate: moment().add(2, "years").toISOString(),
        commerceStartDate: moment().toISOString(),
        currencySymbol: "₹",

        productDescription: product?.productDescription || "",
        skuId: product?.skuId || "",
        brand: product?.brand || "",
        origin: getSelectedCountryCodeByName(
          product?.origin?.name,
          countryList
        ),
        productPhoto: [],

        productMainCategory: product?.productMainCategory || [],
        productSubCategory: product?.productSubCategory || [],
        productSubCategory2: product?.productSubCategory2 || [],

        gstInfo: product?.gstInfo,
        productOriginalPrice: Number(product?.productOriginalPrice),
        productSalePrice: Number(product?.productSalePrice),
        percentageOff: Number(
          (
            100 -
            (Number(product?.productSalePrice) /
              Number(product?.productOriginalPrice)) *
              100
          ).toFixed(2)
        ),
        minOrderQuantity: Number(product?.minOrderQuantity),
        maxOrderQuantity: Number(product?.maxOrderQuantity),
        availableQuantity: Number(product?.availableQuantity),
        alertQuantity:
          Number(product?.alertQuantity) ||
          Number(product?.maxOrderQuantity) * 3,

        measurementInfo: {
          length: product?.measurementInfo?.length,
          height: product?.measurementInfo?.height,
          width: product?.measurementInfo?.width,
          weight: Number(product?.netProductWeight) || 0,
        },
        netProductWeight: product?.measurementInfo?.weight,

        label: product?.label || [{ code: "", value: [] }],
        refLink: product?.refLink || [{ code: "", link: "" }],

        productDisplayUnitOfMeasure: {
          unit: product?.unitOfmeasurement?.toLowerCase() || "",
          value: product?.unitOfmeasurementValue || "",
        },

        // Ondc info
        ondcEnabled: product?.ondcEnabled?.toLowerCase() || "no",
        ondc: {
          ...dbSpecificationObj?.ondc,
          productCode: {
            key: product?.productCodeKey || "OTHERS",
            value: product?.productCodeValue || "",
          },
          fragile: ondcInfo?.fragile || false,
          available_on_cod: ondcInfo?.available_on_cod || false,

          timeToShip: formatTimeToShip(timeToShipUnit, ondcInfo?.shipmentTime),

          cancelTerms: {
            cancellable: cancelTermsInfo?.cancellable?.toLowerCase() || "no",
            // cancellationFeeAmount: cancelTermsInfo?.cancellationFeeAmount || "",
            cancellationFeeAmount: null,
            cancellationFeePercentage: Number(
              cancelTermsInfo?.cancellationFeePercentage
            ),
            refundEligible: cancelTermsInfo?.refundEligible || "no",
          },

          returnTerms: {
            returnable: returnTermsInfo?.returnable?.toLowerCase() || "no",
            returnPeriod: `P${ondcInfo?.returnPeriodDays || 0}D`,
            seller_pickup_return:
              returnTermsInfo?.seller_pickup_return?.toLowerCase() || "no",
          },
        },
      };
      updatePostData.push({
        updateProduct: data,
        addImagePostData,
        deleteImagePostData,
      });
    }
  });

  console.log("updatePostData:", updatePostData);

  return updatePostData;
};

// Ecommerce Catalog Controls post data
export const prepareUpdateCatalogControlPostData = (data) => {
  const { commerceInfo, catalogPartnerInfo } = data;
  const profileId = getProfileId();

  const postData = {
    ...commerceInfo,
    catalogPartnerInfo: [
      {
        catalogPartner: catalogPartnerInfo?.catalogPartner || "",
        warehouse: {
          facilityName: catalogPartnerInfo?.facilityName,
          facilityCode: catalogPartnerInfo?.facilityCode,
        },
        addedDate:
          commerceInfo?.catalogPartnerInfo?.[0]?.addedDate ||
          moment().valueOf(),
        updatedDate: moment().valueOf(),
        status: "active",
      },
    ],
    updatedOn: moment().valueOf(),
    updatedBy: profileId,
  };

  return postData;
};
